import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  getCreatePastOrder,
  getInvoiceBusinessUnitList,
  getInvoiceSupplierList,
  getAllInvoiceDetailslist,
} from "../../../service/Invoice/InvoiceService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getSuppliersList,
  getActiveSupplier,
} from "../../../service/Suppliers/SuppliersService";
import ReactPaginate from "react-paginate";
import SpinnerComponent from "../../components/SpinnerComponent";
import instance from "../../../WebApi/WebApi";
import { useTranslation } from "react-i18next";

const Suppliers = () => {
  const { t } = useTranslation();
  const [isActive, setActive] = useState("false");
  const [SupplierDataList, setAllSupplierDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const PER_PAGE = 10;

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const offset = currentPage * PER_PAGE;
  const currentPageData = SupplierDataList?.slice(offset, offset + PER_PAGE);

  const pageCount = Math.ceil(SupplierDataList?.length / PER_PAGE);
  const handleToggle = (id, isActive) => {
    setIsLoading(true);
    getActiveSupplier("Supplier", id, isActive ? false : true, (r) => {
      console.log(r, "response");
      if (r.success === true) {
        getInvoiceSupplierDataList();
        setIsLoading(false);
      } else {
        setIsLoading(false);
        // toast.error(r.message)
      }
    });
  };

  useEffect(() => {
    getInvoiceSupplierDataList();
  }, []);

  //list of suppliers
  async function getInvoiceSupplierDataList() {
    setIsLoading(true);
    getSuppliersList().then(function (result) {
      const response = result?.data;
      setAllSupplierDataList(response?.data?.listSupplier);
      setIsLoading(false);
    });
  }

  const onSearch = async (e) => {
    const searchText = e.target.value;

    setSearch(searchText);
    try {
      const response = await instance.get(
        `/customer/supplier/list-supplier?searchKeyword=${searchText}`
      );
      setAllSupplierDataList(response?.data?.data?.listSupplier);
      console.log("response", response);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  return (
    <div className="container-fluid">
      <div className="dbMain suppliersBg">
        <Leftpanel breadcm="Supplier" />
        <div className="dbRight">
          <Header link="/dashboard" title={t("suppliers")} description="" />
          <div className="commonBase">
            <div className="dbtableTop mb-4">
              <div className="dbSearch">
                <input
                  type="search"
                  className="form-control"
                  placeholder={t("search")}
                  onChange={onSearch}
                  value={search}
                />
                <i className="fa-solid fa-magnifying-glass"></i>
              </div>
              <span className="spfound"></span>
              <div className="dbtableSrchbg">
                <button className="commonButton">
                  <Link to="/addsuppliers">
                    <i className="fa-solid fa-plus"></i> {t("Add Suppliers")}
                  </Link>
                </button>
              </div>
            </div>

            <div className="dbMaintable">
              <table>
                <thead>
                  <tr>
                    <th>{t("Name")}</th>
                    <th>{t("Country")}</th>
                    <th>{t("ZIP code")}</th>
                    <th>{t("Contact number")}</th>
                    <th>{t("Email ID")}</th>
                    <th>{t("Industry")}</th>
                    {/* <th>Status</th> */}
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                {isLoading && <SpinnerComponent isLoading={isLoading} />}

                <tbody>
                  {currentPageData?.map((d) => (
                    <tr className={d?.isActive ? null : "inactive"}>
                      <td>
                        <Link
                          to={`/supplierdetailsinfo?id=${d?.id}`}
                          style={{ color: "rgb(13, 110, 253)" }}
                        >
                          {d?.name}
                        </Link>
                        {JSON.parse(localStorage.getItem("gs3_User")).email ===
                        d?.email ? (
                          <span style={{ color: "#4DBA06", marginLeft: "6px" }}>
                            self
                          </span>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>
                        <Link to={`javascript:void(0)`}>{d?.country}</Link>
                      </td>
                      <td>
                        <Link to={`javascript:void(0)`}>{d?.zipCode}</Link>
                      </td>
                      <td>
                        <Link to={`javascript:void(0)`}>{d?.mobile}</Link>
                      </td>
                      <td>
                        <Link to={`javascript:void(0)`}>{d?.email}</Link>
                      </td>
                      <td>
                        <Link to={`javascript:void(0)`}>{d?.industry}</Link>
                      </td>
                      {/* <td><span className='cgbtn'>Active</span></td> */}
                      <td>
                        <button
                          onClick={() => handleToggle(d?.id, d?.isActive)}
                          className="beye"
                        >
                          <i className="fa-light fa-eye"></i>
                          <i className="fa-light fa-eye-slash"></i>
                        </button>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {!isLoading && (
              <ReactPaginate
                previousLabel={"←" + t("Previous")}
                nextLabel={t("Next") + "→"}
                pageCount={pageCount}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                previousLinkClassName={"pagination__link"}
                nextLinkClassName={"pagination__link"}
                disabledClassName={"pagination__link--disabled"}
                activeClassName={"pagination__link--active"}
                forcePage={currentPage}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Suppliers;
